import { OcrUser, OcrAnalysis, OcrAnalyzeResponse } from '@domain/ocrModels';

const runtimeEnv: any = (globalThis as any).window?.__ENV || {};
// @ts-ignore - process.env is provided by Vite at build time
const OCR_BASE = (runtimeEnv.OCR_BASE || process.env.VITE_OCR_BASE || process.env.OCR_BASE || '').replace(/\/$/, '');
// @ts-ignore - process.env is provided by Vite at build time
const OCR_TOKEN = runtimeEnv.OCR_TOKEN || process.env.VITE_OCR_TOKEN || process.env.OCR_TOKEN || '';

async function http<T>(path: string, init?: RequestInit): Promise<T> {
  const url = `${OCR_BASE}${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(OCR_TOKEN)}`;
  const res = await fetch(url, {
    ...init,
    headers: {
      ...(init?.headers || {}),
    },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return (await res.json()) as T;
}

async function httpFormData<T>(path: string, formData: FormData): Promise<T> {
  const url = `${OCR_BASE}${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(OCR_TOKEN)}`;
  const res = await fetch(url, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return (await res.json()) as T;
}

export const OcrApi = {
  analyze: async (file: File, user: string) => {
    const formData = new FormData();
    const fileBlob = new Blob([file], { type: 'application/octet-stream' });
    formData.append('file', fileBlob, file.name);
    formData.append('user', user);
    return httpFormData<OcrAnalyzeResponse>('/api/v1/ocr/analyze', formData);
  },

  getAnalysis: (analysisId: number) => http<OcrAnalysis>(`/api/v1/ocr/analyses/${analysisId}`),

  listUsers: () => http<OcrUser[]>('/api/v1/users'),

  getUserAnalyses: (
    userId: number,
    options?: {
      limit?: number;
      offset?: number;
    }
  ) => {
    const limit = options?.limit ?? 20;
    const offset = options?.offset ?? 0;
    return http<OcrAnalysis[]>(
      `/api/v1/analyses/${userId}?limit=${encodeURIComponent(String(limit))}&offset=${encodeURIComponent(
        String(offset)
      )}`
    );
  },
};

